import { rewardProductSchema } from "./schemas.js";
export const rewardProducts = [
    {
        id: "cover-poster",
        name: "12×18 cover poster",
        pointsCost: 500,
        cashPriceCents: 2_900,
        fulfillment: "GELATO_DRAFT",
        active: true,
    },
    {
        id: "story-art-cards",
        name: "Ten 5×7 story-art cards",
        cashPriceCents: 3_900,
        fulfillment: "GELATO_DRAFT",
        active: true,
    },
    {
        id: "poster-card-bundle",
        name: "Poster + ten story-art cards",
        pointsCost: 1_500,
        cashPriceCents: 5_900,
        fulfillment: "GELATO_DRAFT",
        active: true,
    },
    {
        id: "book-voucher",
        name: "Book voucher — any available edition",
        pointsCost: 3_000,
        fulfillment: "VOUCHER",
        active: true,
    },
    {
        id: "extra-book",
        name: "Extra book",
        cashPriceCents: 4_900,
        fulfillment: "GELATO_DRAFT",
        active: true,
    },
];
for (const reward of rewardProducts)
    rewardProductSchema.parse(reward);
export function getRewardProduct(id) {
    return rewardProducts.find((reward) => reward.id === id);
}
//# sourceMappingURL=rewards.js.map